// extracted by mini-css-extract-plugin
module.exports = {"root":"SpaceLookLayout_root__3XfSd","header":"SpaceLookLayout_header__2ss71","sidebar":"SpaceLookLayout_sidebar__1VdiN","content":"SpaceLookLayout_content__2sI-z"};